// Client-side mirror of the document-migration run progress model.
//
// KEEP IN LOCKSTEP with api/src/docMigrationRun.js — the server writes the
// checkpoint into the run's single Message column, this reads it back. Same
// arrangement as docFolders.js mirroring api/src/documentFolders.js.
//
// Only the two functions the UI needs are mirrored; the server owns staleness
// (it is the one that heals a dead run) so that logic deliberately lives there.

const FINISHED = ['done', 'error', 'cancelled'];

// "[3/4] Importing files — 41 of 65" → its parts. A plain message (an error)
// parses with no counter but keeps its text, so nothing stored is lost.
export function parseRunProgress(message) {
  if (typeof message !== 'string') return null;
  const raw = message.trim();
  if (!raw) return null;
  const m = /^\[(\d+)\/(\d+)]\s*(.*)$/.exec(raw);
  if (!m) return { index: null, total: null, label: raw, detail: null, raw };
  const rest = m[3];
  const dash = rest.indexOf(' — ');
  return {
    index:  Number(m[1]),
    total:  Number(m[2]),
    label:  dash === -1 ? rest : rest.slice(0, dash),
    detail: dash === -1 ? null : rest.slice(dash + 3),
    raw,
  };
}

// 0..1 for the progress bar. Deliberately never 1 for an unfinished run: a bar
// sitting full while work continues reads as a hang.
export function runFraction(run) {
  if (!run) return 0;
  if (FINISHED.includes(run.status)) return 1;
  const total = Number(run.fileCount) || 0;
  if (!total) return 0;
  // Clamped to the file count as well as to 0.99 — see the server mirror.
  const settled = Math.min(
    (Number(run.ingested) || 0) + (Number(run.skipped) || 0) + (Number(run.failed) || 0),
    total);
  return Math.max(0, Math.min(0.99, settled / total));
}

export function isRunFinished(status) {
  return FINISHED.includes(status);
}
